import React, { useState } from 'react';
import styled from 'styled-components';
import { Icon } from '../ui';
import { variables } from '../utils';

const TabButton = styled.button.attrs({
  className: 'pointer pb3'
})<{ active?: boolean }>`
  color: ${({ active }) => (active ? variables.navy : variables.blue)};
  border-bottom: 1px solid ${({ active }) => (active ? variables.navy : variables.lightGray)};
  &:hover {
    color: ${variables.navy};
  }
`;

const Spacer = () => <div className="w2 bb b--light-gray" />;

const TabButtonIcon = styled.button.attrs({
  className: 'pointer'
})`
  color: ${variables.blue};
  border-bottom: 1px solid ${variables.lightGray};
  &:hover svg {
    fill: ${variables.navy};
  }
`;

interface PanelNavSmallProps {
  activeTab: 'CAPTION' | 'DATA' | 'NOTE';
  setActiveTab: (value: 'CAPTION' | 'DATA' | 'NOTE') => void;
  showDateModal(value: boolean): void;
}

const PanelNavSmall: React.FC<PanelNavSmallProps> = ({
  activeTab,
  setActiveTab,
  showDateModal
}) => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="sticky bg-white flex-none f6 pt2 ph3 mb3 w-100 mw6-ns center">
      <div className="flex">
        <div className="flex">
          <TabButton
            active={activeTab === 'DATA'}
            onClick={() => setActiveTab('DATA')}
            data-testid="data-tab"
          >
            Data
          </TabButton>
          <Spacer />

          <TabButton
            active={activeTab === 'CAPTION'}
            onClick={() => setActiveTab('CAPTION')}
            data-testid="caption-tab"
          >
            Caption
          </TabButton>
          <Spacer />

          <TabButton
            active={activeTab === 'NOTE'}
            onClick={() => setActiveTab('NOTE')}
            data-testid="note-tab"
          >
            Private Note
          </TabButton>
        </div>
        <div className="bb b--light-gray flex-auto" />
        <TabButtonIcon onClick={() => setMenuOpen(!menuOpen)} data-testid="menu-button">
          <Icon name="dots" className="pb2" />
        </TabButtonIcon>
      </div>

      {menuOpen && (
        <div>
          <button
            className="f7 blue hover-navy bb b--light-gray pv3 pointer w-100"
            onClick={() => showDateModal(true)}
            data-testid="edit-date-button"
          >
            Change Entry Date
          </button>
        </div>
      )}
    </div>
  );
};

export default PanelNavSmall;
